import {pickColor} from "styles";
import {Container} from "./styled";
import {Typography} from "../Typography";
import {useTheme} from "styled-components";
import {Children, Style} from "interfaces";
import {FC, Fragment, ReactNode} from "react";
import {IconProps, Inbox} from "react-feather";
import {SvgIconComponent} from "@mui/icons-material";

export interface EmptyUIStateProps extends Style, Children {
  data: any[];
  body?: ReactNode;
  message?: string;
  icon?: FC<IconProps> | SvgIconComponent;
}

export const EmptyUIState: React.FC<EmptyUIStateProps> = ({
  icon: Icon,
  body,
  data,
  style,
  message,
  children,
}) => {
  const {mode, blackWhite} = useTheme();
  return !data.length ? (
    <Container style={style}>
      {Icon ? (
        <Icon
          size={35}
          strokeWidth={2}
          style={{fontSize: 35, strokeWidth: 2, color: blackWhite}}
        />
      ) : (
        <Inbox size={40} color={pickColor(mode)} />
      )}
      <Typography fontSize={17}>{message ?? "Nada que mostrar aún"}</Typography>
      {body && body}
    </Container>
  ) : (
    <Fragment>{children}</Fragment>
  );
};
